'use strict';

export default [
    'https://static.chewba.info/images/pdf/cover-blue-01.svg',
    // 'https://static.chewba.info/images/pdf/cover-purple-01.svg',
    // 'https://static.chewba.info/images/pdf/cover-beige-01.svg',
    'https://static.chewba.info/images/pdf/cover-salad-photo-01.jpg',
];
